import React from 'react'
import { FemaleIcon, MaleIcon } from '../../Icons/icons.component';
import PropTypes from "prop-types";
const [mColor, fColor] = ["#1976d2", "#b41f5b"]

export function GenderChart({ data: { mValue, fValue } }) {
  const maleValue = 100 - mValue;
  const femaleValue = 100 - fValue;

  return (
    <div className="gender-chart">
      <div className="female-icon">
        <div className="f-txt">
          <p>Female</p>
          <p className="value">{fValue}%</p>
        </div>
        <FemaleIcon
          fillColor={fColor}
          fillValue={femaleValue}
        />
      </div>
      <div className="male-icon">
        <MaleIcon
          fillColor={mColor}
          fillValue={maleValue}
        />
        <div className="m-txt">
          <p>Male</p>
          <p className="value">{mValue}%</p>
        </div>
      </div>
    </div >
  )
}

GenderChart.defaultProps = {
  data: {
    mValue: 0,
    fValue: 0
  }
}

GenderChart.propTypes = {
  data: PropTypes.instanceOf(PropTypes.shape({}))
}
